import { render, staticRenderFns } from "./WfsFolder.vue?vue&type=template&id=977aade4"
import script from "./WfsFolder.vue?vue&type=script&lang=js"
export * from "./WfsFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports